import {
  EHealthProceduresTypes,
  EMedicalViews,
  IFetchHealthProcedures,
  IFetchHealthProceduresParams,
  IHealthProcedures,
  MedicalViewsType
} from '~/interfaces'
import { axios, AxiosResponse } from '~/modules'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchPatientHealthProcedures = <T>(
  selectedMedicalView: MedicalViewsType
): ((params: IFetchHealthProceduresParams) => Promise<T>) => {
  if (selectedMedicalView === EMedicalViews.NONE) {
    throw new Error('Selected Medical View is not defined')
  }

  return async (params: IFetchHealthProceduresParams): Promise<T> => {
    const medicalView = selectedMedicalView === EMedicalViews.MATERNAL_INFANT ? 'maternal-infant' : selectedMedicalView
    const healthProcedureUrl = `${hstoryAPI}/patients/${params.pathParams.patientId}/${medicalView}-health-procedures`
    return await _fetchPatientHealthProcedures<T>(healthProcedureUrl, params.queryParams)
  }
}

const _fetchPatientHealthProcedures = async <T>(
  healthProcedureUrl: string,
  params?: IFetchHealthProceduresParams['queryParams']
): Promise<T> => {
  const response = await axios.get(healthProcedureUrl, params ? { params } : {})
  const { data }: AxiosResponse<T> = response
  return data
}

export const removeUnsupportedEvents = (events: IFetchHealthProcedures): IFetchHealthProcedures => {
  const bySupportedTypes = (event: IHealthProcedures) =>
    Object.values(EHealthProceduresTypes).includes(event.type as unknown as EHealthProceduresTypes)
  return events.filter(bySupportedTypes)
}
